import { CommonModule, UpperCasePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutCompanyComponent } from './auth/about-company/about-company.component';
import { CompanyBranchComponent } from './auth/company-branch/company-branch.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { LoginComponent } from './auth/login/login.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SetPasswordComponent } from './auth/set-password/set-password.component';
import { AuthGuard } from './_guards';
import { AuthModule } from './auth/auth.module';
import { LayoutModule } from './layout/layout.module';
import { AngularMaterialModule } from './material.module';
import { RequestInterceptor } from './shared/interceptors/request.interceptor';
import { ResponseInterceptor } from './shared/interceptors/response.interceptor';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { OpenTrackingOutputComponent } from './tracking-output/open-tracking-output/open-tracking-output.component';
import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { EventEmitterService } from './shared/services/event-emitter.service';

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        CompanyBranchComponent, AboutCompanyComponent,
        ForgetPasswordComponent, ResetPasswordComponent,
        SetPasswordComponent,
        OpenTrackingOutputComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        AppRoutingModule,
        NgxSpinnerModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        AngularMaterialModule,
        AuthModule,
        LayoutModule,
        MatSnackBarModule,
        ToastrModule.forRoot(),
        LoggerModule.forRoot({
            level: NgxLoggerLevel.DEBUG,
            disableConsoleLogging: false
        }),
        NgIdleModule.forRoot(),
        NgIdleKeepaliveModule.forRoot()], providers: [AuthGuard, EventEmitterService, CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        UpperCasePipe, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { }
